import {
  Button,
  IconButton,
  Pagination,
  Stack,
  TableSortLabel,
  ThemeProvider,
  Tooltip,
  Typography,
  Menu,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import {
  FlatList,
  Text,
  View,
  TextInput,
  useWindowDimensions,
} from "react-native";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import SimpleButton from "../components/SimpleButton";
import {
  ClearActionLog,
  ClearCurrentAction,
  ClearFullAnalyseString,
  SetControllerToggle,
} from "../redux/actions/controlAction";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import DashboardStatsBox from "../components/DashboardStatsBox";
import { CloseOutlined, FilterList, SearchOutlined } from "@mui/icons-material";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment/moment";
import UpdateReviewStatusModal from "../components/UpdateReviewStatusModal";
import { useUpdateMatchStatus } from "../hooks/useUpdateMatchStatus";
import { ActivityIndicator } from "react-native-web";
import Multiselect from "multiselect-react-dropdown";
import { trackEvent } from "../utils/mixpanel";

const CustomDateInput = forwardRef(({ value, onClick, className }, ref) => (
  <Button
    className={className}
    onClick={onClick}
    ref={ref}
    sx={{
      height: "40px",
      fontSize: "12px",
      border: "1px solid #f1f1f1",
      borderRadius: "4px",
      color: "#12121370",
      textTransform: "none",
      fontWeight: "400",
    }}
  >
    {value || "Select Date"}
  </Button>
));

const Home = (props) => {
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const multiselectRefAnalyzed = useRef(null);
  const matchList = props.matchList;
  const query = useQuery();
  const page = query.get("page");
  const history = useHistory();
  const dispatch = useDispatch();
  // const matchList = props.matchList?.flatMap((item) =>
  //   item?.data?.map((i) => i)
  // );
  const { width } = useWindowDimensions();
  const isMobile = width < 850;
  const [searchMatchId, setSearchMatchId] = useState();
  const [searchTournament, setSearchTournament] = useState();
  const [searchTeam, setSearchTeam] = useState();
  const [searchByAnalyzed, setSearchByAnalyzed] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [sortWith, setSortWith] = useState();
  const [mainListData, setMainListData] = useState([]);
  const [filterShown, setFilterShown] = useState(false);
  const [selectAnalyzedArray, setSelectAnalyzedArray] = useState([]);

  useEffect(() => {
    dispatch(ClearActionLog());
    dispatch(ClearCurrentAction());
    dispatch(ClearFullAnalyseString());
  }, [dispatch]);

  useEffect(() => {
    setMainListData(props.matchList.match_data.data || []);
  }, [props.matchList]);

  const analysisOptions = [
    { value: 1, label: "Match Created" },
    { value: 2, label: "Video Uploaded" },
    { value: 3, label: "Analysis Done" },
    { value: 4, label: "Resources Assigned" },
    { value: 5, label: "Analysis In Progress" },
    { value: 6, label: "Review In Progress" },
    { value: 7, label: "Completed" },
    { value: 8, label: "Mark For Review" },
    { value: 9, label: "Issue Found" },
  ];

  const sortWithOptions = [
    { value: "id", label: "Match id" },
    { value: "match_day", label: "Tournament Name" },
  ];

  const handleSearch = () => {
    if (props?.onPress) {
      props.onPress({
        page: 0,
        searchMatchId,
        searchTournament,
        searchTeam,
        searchByAnalyzed: selectAnalyzedArray,
        startDate: startDate
          ? new Intl.DateTimeFormat("fr-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(startDate)
          : "",
        endDate: endDate
          ? new Intl.DateTimeFormat("fr-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            }).format(endDate)
          : "",
      });
    }
  };

  const formatTimeFromSecondsToMinutes = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}mins ${secs}secs`;
  };

  const handleReset = () => {
    setSearchMatchId("");
    setSearchTournament("");
    setSearchTeam("");
    setStartDate("");
    setEndDate("");
    if (multiselectRefAnalyzed.current) {
      multiselectRefAnalyzed.current.resetSelectedValues();
    }
    if (props?.onPress) {
      props.onPress({
        page: 0,
        searchMatchId,
        searchTournament,
        searchTeam,
        searchByAnalyzed: [],
        startDate: "",
        endDate: "",
      });
    }
  };

  const handleSort = (value) => {
    if (value === "match_day") {
      const sortedByName = mainListData?.sort((a, b) => {
        const tournamentNameA = a.tournament_name.toUpperCase();
        const tournamentNameB = b.tournament_name.toUpperCase();
        return tournamentNameA[0].localeCompare(tournamentNameB[0]);
      });
      setMainListData(sortedByName);
    } else if (value === "id") {
      const sortById = mainListData?.sort((a, b) => {
        return a.id - b.id;
      });
      setMainListData(sortById);
    }
  };

  const styles = {
    container: {
      width: "100%",
      flex: 1,
      justifyContent: "flex-start",
      alignItems: "center",
      paddingVertical: "0px",
      paddingHorizontal: isMobile ? "10px" : "20px",
    },
    sectionTitle: {
      width: "100%",
      padding: isMobile ? 5 : 20,
      justifyContent: "flex-start",
      alignItems: "center",
      flexDirection: "row",
      marginBottom: isMobile ? 5 : 10,
    },
    title: {
      fontFamily: "Roboto",
      fontWeight: "500",
      fontSize: isMobile ? 10 : 14,
      color: "#131313",
      opacity: 0.8,
    },
    attributeBox: {
      margin: 5,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      padding: 5,
      borderRadius: 2,
      backgroundColor: "#21212e",
    },
    attribTitle: {
      fontFamily: "Roboto",
      fontWeight: "500",
      fontSize: isMobile ? 10 : 14,
      color: "#fff",
      letterSpacing: 0.5,
    },
  };

  return (
    <View style={styles.container}>
      <Stack
        sx={{
          backgroundColor: "#fff",
          width: "100%",
          justifyContent: "center",
          alignItems: "flex-start",
          marginBottom: 1,
        }}
      >
        <Typography
          sx={{
            fontSize: { lg: "16px", md: "14px", xs: "12px" },
            fontWeight: "500",
            marginBottom: "5px",
            color: "rgba(9, 16, 29, 1)",
          }}
        >
          Progress Overview
        </Typography>

        <Stack
          sx={{
            width: "100%",
            marginTop: 0.5,
            gap: 1,
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: { xs: "space-around", md: "space-evenly" },
          }}
        >
          <DashboardStatsBox
            value={matchList?.analyst_overview?.total_matches_assigned}
            title="Total Matches Assigned"
            desc="Total matches assigned to you."
            valueColor="rgba(12, 157, 65, 0.1)"
          />
          <DashboardStatsBox
            value={matchList?.analyst_overview?.analysed_matches}
            title="Analysis Completed"
            desc="No. of match analysis completed."
            valueColor="rgba(12, 157, 65, 0.1)"
          />

          <DashboardStatsBox
            value={matchList?.analyst_overview?.in_progress_matches}
            title="Analysis in progress"
            desc="No. of match analysis in progress."
            valueColor="rgba(232, 108, 0, 0.1)"
          />
          <DashboardStatsBox
            title="Overall Progress"
            desc={
              <Stack flexDirection="row" gap={0.5}>
                <Typography
                  style={{
                    fontSize: "10px",

                    color: "rgba(57, 68, 82, 1)",
                  }}
                >
                  Your avg. TAT
                </Typography>
                <Typography
                  style={{
                    fontSize: "10px",
                    fontWeight: "500",
                    color: "rgba(25, 171, 79, 1)",
                  }}
                >
                  {matchList?.analyst_overview?.average_tat
                    ? formatTimeFromSecondsToMinutes(
                        matchList?.analyst_overview?.average_tat
                      )
                    : "NA"}
                </Typography>
              </Stack>
            }
            valueColor="transparent"
            valueComponent={
              <View
                style={{
                  height: "100%",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgressbar
                  value={
                    (matchList?.analyst_overview?.analysed_matches /
                      matchList?.analyst_overview?.total_matches_assigned) *
                    100
                  }
                  strokeWidth={12}
                  styles={buildStyles({
                    rotation: 0.25,
                    strokeLinecap: "butt",
                    pathTransitionDuration: 0.5,
                    pathColor: "rgba(12, 157, 65, 1)",
                    trailColor: "rgba(217, 217, 217, 1)",
                  })}
                />
                <Typography
                  sx={{
                    fontSize: { md: "12px", xs: "10px" },
                    fontWeight: "400",
                    color: "rgba(57, 68, 82, 1)",
                    position: "absolute",
                  }}
                >
                  {parseInt(
                    (matchList?.analyst_overview?.analysed_matches /
                      matchList?.analyst_overview?.total_matches_assigned) *
                      100
                  )}
                  {"%"}
                </Typography>
              </View>
            }
          />
        </Stack>
      </Stack>

      <View
        style={{
          height: 1,
          width: "100%",
          backgroundColor: "#f1f1f1",
          marginVertical: "1em",
        }}
      />

      <Stack
        width={"100%"}
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        sx={{ zIndex: 9999 }}
      >
        <Stack>
          <Typography
            sx={{
              marginBottom: "2px",
              fontSize: { lg: "14px", md: "12px", xs: "12px" },
            }}
          >
            Sort by
          </Typography>
          <Select
            styles={{
              control: (styles) => ({
                ...styles,
                minWidth: "120px",
              }),
              menu: (styles) => ({ ...styles, fontSize: "12px" }),
              container: (styles) => ({
                ...styles,
                height: 40,
              }),
              input: (styles) => ({
                ...styles,
                fontSize: "12px",
              }),
              placeholder: (styles) => ({
                fontSize: "12px",
                ...styles,
              }),
            }}
            value={sortWith}
            onChange={(e) => {
              setSortWith(e);
              handleSort(e.value);
            }}
            options={sortWithOptions}
            isSearchable={false}
          />
        </Stack>
        <Tooltip title={`${filterShown ? "Hide" : "Show"} search/filter`}>
          <Stack
            gap={1}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            {filterShown && (
              <Typography sx={{ fontSize: "14px", color: "gray" }}>
                Hide Filters
              </Typography>
            )}
            <IconButton
              onClick={() => setFilterShown(!filterShown)}
              sx={{
                fontSize: "16px",
                backgroundColor: "orange",
                color: "#fff",
                ":hover": {
                  backgroundColor: "darkorange",
                },
              }}
            >
              {filterShown ? <CloseOutlined /> : <FilterList />}
            </IconButton>
          </Stack>
        </Tooltip>
      </Stack>
      {filterShown && (
        <Stack
          sx={{
            gap: 1,
            width: "100%",
            flexDirection: "row",
            zIndex: 10,
            marginBottom: 1,
            marginTop: 1,
            flexWrap: "wrap",
            justifyContent: "flex-start",
            alignItems: "flex-end",

            // flexWrap: "wrap",
          }}
        >
          <Stack>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              Search by Match ID
            </Typography>
            <TextInput
              style={{
                height: 40,
                borderColor: "#f1f1f1",
                borderWidth: 1,
                fontSize: "12px",
                paddingHorizontal: 10,
                borderRadius: 4,
              }}
              placeholder="Enter Match id"
              keyboardType="numeric"
              value={searchMatchId}
              onChangeText={(text) => {
                setSearchMatchId(text);
              }}
            />
          </Stack>

          <View>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              Search by Tournament
            </Typography>
            <TextInput
              style={{
                height: 40,
                borderColor: "#f1f1f1",
                borderWidth: 1,
                fontSize: "12px",
                paddingHorizontal: 10,
                borderRadius: 4,
              }}
              placeholder="Enter Tournament name"
              value={searchTournament}
              onChangeText={(text) => {
                setSearchTournament(text);
              }}
            />
          </View>

          <View>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              Search by Team{" "}
            </Typography>
            <TextInput
              style={{
                height: 40,
                borderColor: "#f1f1f1",
                borderWidth: 1,
                fontSize: "12px",
                paddingHorizontal: 10,
                borderRadius: 4,
              }}
              placeholder="Enter Team Name"
              value={searchTeam}
              onChangeText={(text) => {
                setSearchTeam(text);
              }}
            />
          </View>

          <View>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              Filter by Status
            </Typography>

            <Multiselect
              ref={multiselectRefAnalyzed}
              showCheckbox
              displayValue="label"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={(list) => {
                setSelectAnalyzedArray(list.map((i) => i.value));
              }}
              onSearch={function noRefCheck() {}}
              onSelect={(value) => {
                setSelectAnalyzedArray(value.map((i) => i.value));
              }}
              options={analysisOptions}
              style={{
                searchBox: {
                  fontSize: "12px",
                  minHeight: "39px",
                  maxHeight: "39px",
                  borderColor: "#f1f1f1",
                },
              }}
            />
          </View>

          <Stack>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              Start date{" "}
            </Typography>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              customInput={<CustomDateInput className="" />}
            />
          </Stack>

          <Stack>
            <Typography
              sx={{
                marginBottom: "2px",
                fontSize: { lg: "14px", md: "12px", xs: "12px" },
              }}
            >
              End Data{" "}
            </Typography>
            <DatePicker
              customInput={<CustomDateInput className="" />}
              selected={endDate}
              onChange={(date) => setEndDate(date)}
            />
          </Stack>

          <Stack
            sx={{
              flex: 1,
              gap: 2,

              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              onClick={() => {
                handleReset();
              }}
              size="small"
              variant="outlined"
              color="secondary"
              sx={{
                textTransform: "none",
              }}
              startIcon={<CloseOutlined color="#12121280" fontSize="12px" />}
            >
              Reset
            </Button>

            <Button
              onClick={() => {
                handleSearch();
              }}
              size="small"
              variant="contained"
              color="primary"
              sx={{
                textTransform: "none",
              }}
              startIcon={<SearchOutlined color="#12121280" fontSize="12px" />}
            >
              Search
            </Button>
          </Stack>
        </Stack>
      )}
      {props.isLoading && (
        <Stack>
          <CircularProgress />
        </Stack>
      )}
      <TableContainer
        sx={{ mt: 1, position: "relative", minHeight: "60vh" }}
        component={Paper}
      >
        <Table stickyHeader size="small">
          <ListHeader />
          {!props.isLoading && mainListData?.length === 0 && (
            <Typography sx={{ p: 5 }}>No Data Found !!</Typography>
          )}

          {mainListData?.map((item) => (
            <ItemCard
              isLoading={props.isLoading || props.isRefetching}
              isMobile={isMobile}
              match={item}
              hasSense
              onAnalysePress={() => dispatch(SetControllerToggle(true))}
            />
          ))}
        </Table>
      </TableContainer>
      {props.isRefetching && (
        <Stack
          sx={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            mt: 1,

            backgroundColor: "rgba(255,255,255,0.5)",
          }}
        >
          <ActivityIndicator size="small" />
        </Stack>
      )}
      <Pagination
        sx={{ my: 1 }}
        // defaultPage={parseInt(3)}
        count={Math.ceil(props?.count / 20)}
        onChange={(_, value) => {
          handleReset();
          setSortWith("");
          props.setPage && props.setPage((parseInt(value) - 1) * 20);
        }}
      />
    </View>
  );
};

const ItemCard = (props) => {
  const { match, isMobile } = props;


  
  let history = useHistory();

  const { analystName, token } = useSelector((state) => ({
    token: state.auth.token,
    analystName: state.auth.analystName,
  }));

  const isAnalyst = match.analyst_details?.some(
    (analyst) => analyst.name === analystName
  );
  const isReviewer = match.reviewer_details?.some(
    (reviewer) => reviewer.name === analystName
  );

  // console.log("isReviewer", isReviewer);
  // console.log("isAnalyst", isAnalyst);
  // console.log("match id", match.id);
  // console.log("match status", match.status);

  let statusText = "";
  let actionText = "";
  let statusTextColor = "";
  let statusBorderColor = "";
  let actionBorderColor = "";
  let actionTextColor = "";
  let actionBgColor = "";

  switch (match.status) {
    case 0:
      statusText = "Inactive";
      statusTextColor = "rgba(109, 117, 128, 1)";
      statusBorderColor = "rgba(109, 117, 128, 1)";
      actionText = "Assign";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(232, 108, 0, 0.5)";
      break;
    case 1:
      statusText = "Match Created";
      statusTextColor = "rgba(109, 117, 128, 1)";
      statusBorderColor = "rgba(109, 117, 128, 1)";
      actionText = "Assign";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(232, 108, 0, 0.5)";
      break;
    case 2:
      statusText = "Video Uploaded";
      statusTextColor = "rgba(46, 90, 172, 1)";
      statusBorderColor = "rgba(46, 90, 172, 1)";
      actionText = "Assign";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(232, 108, 0, 1)";
      break;
    case 3:
      statusText = "Analysis Done";
      statusTextColor = "rgba(40, 125, 60, 1)";
      statusBorderColor = "rgba(40, 125, 60, 1)";
      actionText = isReviewer ? "Review" : "Reanalyse";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(25, 171, 79, 1)";
      break;
    case 4:
      statusText = "Resource Assigned";
      statusTextColor = "rgba(46, 90, 172, 1)";
      statusBorderColor = "rgba(46, 90, 172, 1)";
      actionText = "Analyse";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(25, 171, 79, 1)";
      break;
    case 5:
      statusText = "Analysis In-Progress";
      statusTextColor = "rgba(46, 90, 172, 1)";
      statusBorderColor = "rgba(46, 90, 172, 1)";
      actionText = isReviewer
        ? isReviewer && isAnalyst
          ? "Analyze"
          : "Review"
        : "Analyse";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(25, 171, 79, 1)";
      break;
    case 6:
      statusText = "Review In-Progress";
      statusTextColor = "rgba(46, 90, 172, 1)";
      statusBorderColor = "rgba(46, 90, 172, 1)";
      actionText = "In Progress";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(232, 108, 0, 1)";
      break;
    case 7:
      statusText = "Completed";
      statusTextColor = "rgba(40, 125, 60, 1)";
      statusBorderColor = "rgba(40, 125, 60, 1)";
      actionText = isReviewer
        ? isAnalyst && isReviewer
          ? "Reanalyze"
          : "Review"
        : "Reanalyze";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(25, 171, 79, 1)";
      break;
    case 8:
      statusText = "Marked for review";
      statusTextColor = "rgba(40, 125, 60, 1)";
      statusBorderColor = "rgba(40, 125, 60, 1)";
      actionText = "Review";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(25, 171, 79, 1)";
      break;
    case 9:
      statusText = "Issue Found";
      statusTextColor = "rgba(218, 20, 20, 1)";
      statusBorderColor = "rgba(218, 20, 20, 1)";
      actionText = "In Progress";
      actionTextColor = "rgba(255, 255, 255, 1)";
      actionBgColor = "rgba(232, 108, 0, 1)";
      break;
  }

  const formatTimeFromSeconds = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${hrs.toString()}hrs,${mins.toString()}mins`;
  };

  const styles = {
    cardText: {
      fontWeight: 400,
      fontSize: "1em",
      paddingVertical: "1em",
    },
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const { isUpdateLoading, mutateUpdateMatchStatus } = useUpdateMatchStatus({
    onClose: handleClose,
  });


  
  const handleAnalysePress = () => {
  //    if (match.status === 8 && isReviewer) {
  //   history.push(`/review/${match.id}`);
  //   return;
  // }
    if (
      (match.status === 6 || //Review In Progress
        match.status === 8|| //Mark For Review
        match.status === 3 || //Analysis Done
        match.status === 9) && //Issue Found
      isReviewer
    ) {
      localStorage.setItem("videoTabTat", JSON.stringify({ [match?.id]: 0 }));
      trackEvent().track('clicked_on_review', { match_id: match.id, match_status: match.status });
       history.push(`/review/${match.id}`);
      return;
    }
    handleReanalyze();
  };

  const handleReanalyze = () => {
    localStorage.setItem("videoTabTat", JSON.stringify({ [match?.id]: 0 }));
    const eventName = match.status === 3 || match.status === 7 ? 'clicked_on_reanalyze' : 'clicked_on_analyze';
    trackEvent().track(eventName, { match_id: match.id, match_status: match.status });
    isMobile
      ? history.push(`/analyse/${match.id}`)
      :
       match?.analysis_setup === 3
      ? history.push(`/videoplayer?match_id=${match.id}`)
      : history.push(`/videoplayerold?match_id=${match.id}`);
  };

  const handleReview = () => {
    trackEvent().track('clicked_on_mark_for_review', { match_id: match.id, match_status: match.status });
    mutateUpdateMatchStatus({ token, match_id: match.id, match_status: 8 });
  };

  const ActionButton = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
      setAnchorEl(null);
    };

    const isAnalysisCompleted = match.status === 3;
    const isMarkForReview = match.status === 8;
    const isReviewInProgress = match.status === 6;
    const isIssueFound = match.status === 9;

    let buttonContent;

    switch (true) {
      case !isAnalysisCompleted && !isIssueFound && !isReviewer && isAnalyst:
        buttonContent = (
          <Button
            disabled={props.isLoading}
            onClick={() => {
              if (match.status === 6 || match.status === 8) return;
              handleAnalysePress();
            }}
            sx={{
              minWidth: "120px",
              backgroundColor:
                match.status === 6 || match.status === 8
                  ? "rgba(25, 171, 79, 1)"
                  : actionBgColor,
              color: actionTextColor,
              borderRadius: "0.2em",
              textAlign: "center",
              "&:hover": {
                backgroundColor:
                  match.status === 6 || match.status === 8
                    ? "rgba(25, 171, 79, 1)"
                    : actionBgColor,
              },
              opacity: match.status === 6 || match.status === 8 ? 0.5 : 1,
              pointerEvents:
                match.status === 6 || match.status === 8 ? "none" : "auto",
            }}
            variant="contained"
          >
            {props.isLoading ? (
              <CircularProgress size={20} />
            ) : (
              <Typography
                sx={{
                  fontSize: isMobile ? "0.5em" : "1em",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlign: "center",
                }}
              >
                {match.status === 6 || match.status === 8
                  ? "Action"
                  : actionText}
              </Typography>
            )}
          </Button>
        );
        break;

      case !isAnalysisCompleted &&
        isReviewer &&
        !isMarkForReview &&
        !isIssueFound &&
        !isReviewInProgress:
        buttonContent = (
          <Button
            disabled={props.isLoading}
            onClick={() => {
              if (isReviewer && isAnalyst) {
                handleAnalysePress();
              }
            }}
            sx={{
              minWidth: "120px",
              backgroundColor: actionBgColor,
              color: actionTextColor,
              borderRadius: "0.2em",
              textAlign: "center",
              "&:hover": {
                backgroundColor: actionBgColor,
              },
              opacity: isReviewer && isAnalyst ? 1 : 0.5,
              pointerEvents: isReviewer && isAnalyst ? "auto" : "none",
            }}
            variant="contained"
          >
            {props.isLoading ? (
              <CircularProgress size={18} />
            ) : (
              <Typography
                sx={{
                  fontSize: isMobile ? "0.5em" : "1em",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlign: "center",
                }}
              >
                {actionText}
              </Typography>
            )}
          </Button>
        );
        break;

      case (isReviewer &&
        (isMarkForReview || isIssueFound || isReviewInProgress) &&
        !isAnalyst) ||
        (isReviewer && isAnalyst && isMarkForReview) ||
        (isReviewer && isAnalyst && isReviewInProgress):
        buttonContent = (
          <Button
            disabled={props.isLoading}
            onClick={() => {
              if (
                (isReviewer && isAnalyst) ||
                (isReviewer && (isMarkForReview || isReviewInProgress))
              ) {
                handleAnalysePress();
              }
            }}
            variant="contained"
            sx={{
              minWidth: "120px",
              backgroundColor: "rgba(25, 171, 79, 1)",
              color: actionTextColor,
              borderRadius: "0.2em",
              textAlign: "center",
              "&:hover": { backgroundColor: "rgba(25, 171, 79, 1)" },
              opacity:
                (isReviewer && isAnalyst) ||
                (isReviewer && (isMarkForReview || isReviewInProgress))
                  ? 1
                  : 0.5,
              pointerEvents:
                (isReviewer && isAnalyst) ||
                (isReviewer && (isMarkForReview || isReviewInProgress))
                  ? "auto"
                  : "none",
              fontSize: isMobile ? "0.5em" : "1em",
              overflowWrap: "normal",
              whiteSpace: "nowrap",
            }}
          >
            {props.isLoading ? <CircularProgress size={20} /> : "Review"}
          </Button>
        );
        break;

      case (isAnalysisCompleted && !isReviewer) ||
        (isIssueFound && !isReviewer) ||
        (isMarkForReview && !isReviewer) ||
        ((isAnalysisCompleted || isIssueFound) && isReviewer && isAnalyst):
        buttonContent = (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            <Button
              disabled={props.isLoading}
              id="menu-button"
              aria-controls={open ? "menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
              variant="contained"
              sx={{
                minWidth: "120px",
                backgroundColor: "rgba(25, 171, 79, 1)",
                color: actionTextColor,
                borderRadius: "0.2em",
                textAlign: "center",
                "&:hover": {
                  backgroundColor: "rgba(25, 171, 79, 1)",
                },
                opacity: isMarkForReview && !isReviewer ? 0.5 : 1,
                pointerEvents: isMarkForReview && !isReviewer ? "none" : "auto",
                fontSize: isMobile ? "0.5em" : "1em",
                overflowWrap: "normal",
                whiteSpace: "nowrap",
              }}
            >
              {props.isLoading ? <CircularProgress size={20} /> : " Action"}
            </Button>
            <Menu
              id="menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              MenuListProps={{
                "aria-labelledby": "menu-button",
              }}
            >
              <MenuItem onClick={handleReanalyze} disabled={isUpdateLoading}>
                Reanalyze
              </MenuItem>
              <MenuItem onClick={handleReview} disabled={isUpdateLoading}>
                {isUpdateLoading ? "Updating..." : "Mark for review"}
              </MenuItem>
            </Menu>
          </div>
        );
        break;

      default:
        buttonContent = (
          <Button
            sx={{
              minWidth: "120px",
              backgroundColor: actionBgColor,
              color: actionTextColor,
              borderRadius: "0.2em",
              textAlign: "center",
              "&:hover": {
                backgroundColor: actionBgColor,
              },
              opacity: 0.5,
              pointerEvents: "none",
            }}
            variant="contained"
          >
            <Typography
              sx={{
                fontSize: isMobile ? "0.5em" : "1em",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "center",
              }}
            >
              {actionText}
            </Typography>
          </Button>
        );
    }
    return <>{buttonContent}</>;
  };

  return (
    <>
      <UpdateReviewStatusModal
        open={isModalOpen}
        onClose={handleClose}
        isProgress={match.status === 6}
        isCompleted={match.status === 7}
        issueFound={match.status === 9}
        matchId={match.id}
      />
      <TableRow
        key={match.id}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 888,
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              backgroundColor: "#fff",
            },
          }}
          component="th"
          scope="row"
        >
          {match?.id}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
            },
          }}
          align="center"
        >
          {moment(match.created_at).format("DD MMM YY")}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
            },
          }}
        >
          {match.tournament_name}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
            },
          }}
          align="right"
        >
          {match.team_a_details.name}
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
            },
          }}
          align="left"
        >
          {match.team_b_details.name}
        </TableCell>
        <TableCell align="center">
          <Typography
            sx={{
              border: "1px solid",
              borderColor: statusBorderColor,
              padding: 0.5,
              borderRadius: "2px",
              color: statusTextColor,
              fontWeight: 600,
              fontSize: { lg: "12px", md: "10px", xs: "8px" },
            }}
          >
            {statusText}
          </Typography>
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
            },
          }}
          align="center"
        >
          {match.analyst_tat ? formatTimeFromSeconds(match.analyst_tat) : "0"}
        </TableCell>

        <TableCell align="right">
          <ActionButton />
        </TableCell>

        <TableCell align="right">
          <Button
            disabled={match.live_tagging_status === null}
            onClick={() => {
              history.push(`/live-analyse/${match.id}`);
            }}
            variant="contained"
            color="primary"
            sx={{
              textTransform: "none",
              borderRadius: "4px",
              padding: "6px 4px",
              fontSize: isMobile ? "0.5em" : "1em",
            }}
          >
            Live Tag
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

const ListHeader = ({ isMobile }) => {
  return (
    <TableHead sx={{ backgroundColor: "#121213" }}>
      <TableRow
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
        }}
      >
        <TableCell
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 999,
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          component="th"
          scope="row"
        >
          Match ID
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Created Date
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              lineHeight: "120%",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Tournament Name
        </TableCell>
        <TableCell
          align="right"
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
        >
          Team A
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
          align="left"
        >
          Team B
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
          align="left"
        >
          Status
        </TableCell>

        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          TAT
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Action
        </TableCell>
        <TableCell
          sx={{
            fontSize: {
              lg: "14px",
              md: "12px",
              xs: "10px",
              color: "#121213",
              fontWeight: "500",
              fontFamily: "Poppins",
              color: "#fff",
              backgroundColor: "#121213",
            },
          }}
          align="center"
        >
          Action 2
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default Home;
